import { useContext } from 'react';

import PracticeView from './PracticeView';
import ProviderView from './ProviderView';

import * as api from '../../../api';
import _ from 'lodash';
import MultiView from './MultiView';
import { SchedulingContext } from '../../../scenes/Form/ScheduleAppointmentPage/SchedulingContext';

const ScheduleAppointment: React.FC = () => {
  const { fieldConfig, availableEhrTimeSlots, patientOrder } =
    useContext(SchedulingContext);

  const scheduleAppointmentDisplayBy =
    fieldConfig.scheduleAppointmentDisplayBy ??
    api.PrevisitFormTemplateFieldConfig.ScheduleAppointmentDisplayBy.Practice;

  switch (scheduleAppointmentDisplayBy) {
    case api.PrevisitFormTemplateFieldConfig.ScheduleAppointmentDisplayBy
      .Practice:
      if (_.uniqBy(availableEhrTimeSlots, 'practiceId').length > 1) {
        return <MultiView />;
      }
      return <PracticeView />;
    case api.PrevisitFormTemplateFieldConfig.ScheduleAppointmentDisplayBy
      .Provider:
      if (
        patientOrder?.alternateReferredToProvider ||
        _.uniqBy(availableEhrTimeSlots, 'providerId').length > 1
      ) {
        return <MultiView />;
      }
      return <ProviderView />;
    default:
      const s: never = scheduleAppointmentDisplayBy;
      void s;
      return null;
  }
};

export default ScheduleAppointment;
